import React, { useState, useEffect, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import { IconButton, InputAdornment, Switch } from '@mui/material';
// import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
// import moment from 'moment/moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import styled from 'styled-components';
import { ModalPPVPriceContext } from '../ModalPPVPrice/context';

import './style.darkmode.scss';
import { POST_TYPE } from '../../utils/constants';
import { connect } from 'react-redux';

const DateInformation = styled.div`
    color: #0097fe;
    padding-top: 8px;
`;

const ModalPPVPrice = ({ user, onPosts = false }) => {
    // const [busy, setBusy] = useState(false);
    // const [showCalendar, setShowCalendar] = useState(false);
    const [priceHelpText, setPriceHelpText] = useState('');
    const [promoPriceHelpText, setPromoPriceHelpText] = useState('');
    const [priceError, setPriceError] = useState(false);
    const [promoPriceError, setPromoPriceError] = useState(false);

    const { showPrice,
        handlePriceModalClose,
        ppvPrice,
        setPpvPrice,
        promoPrice,
        setPromoPrice,
        isDiscounted,
        setIsDiscounted,
        minPpvPrice,
        maxPpvPrice,
        expiry,
        setExpiry,
        dispatchAlert,
        onShop = false,
        showOnShopAndPosts = false,
        setShowOnShopAndPosts = () => { },
        postType,
        setPostType
    } = useContext(ModalPPVPriceContext);

    const handleClose = () => {
        handlePriceModalClose();
    };

    const handleCancel = () => {
        handlePriceModalClose('cancel');
    };

    const handleOk = () => {
        if (priceError || promoPriceError) {
            return;
        }

        if (isDiscounted && expiry.days === 0 && expiry.hours === 0 && expiry.minutes === 0) {
            dispatchAlert('Limited expiry is needed.');
            return;
        }

        handlePriceModalClose('ok');
    };

    const handlePriceChange = e => {
        const value = e.target.value;
        const formattedPrice = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        }).replace(/[^.\d]/g, '');

        setPpvPrice(formattedPrice);
    };

    const handlePromoPriceChange = e => {
        const value = e.target.value;
        const formattedPrice = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        }).replace(/[^.\d]/g, '');

        if (parseFloat(formattedPrice) >= parseFloat(ppvPrice)) {
            return;
        }

        setPromoPrice(formattedPrice);
    };

    const handleIsDiscounted = () => {
        setIsDiscounted(isDiscounted => !isDiscounted);
    };

    // const handleToggleCalendar = () => {
    //     setShowCalendar(showCalendar => !showCalendar);
    // };

    // const handleAcceptDate = (value) => {
    //     setDateError('');
    //     setExpiryDate(value);
    //     // setShowCalendar(false);
    // };

    // const handleCloseCalendar = () => {
    //     setShowCalendar(false);
    // };

    useEffect(() => {
        setPriceHelpText(`Min $${minPpvPrice} USD`);
    }, []);

    useEffect(() => {
        if (isDiscounted) {
            setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
        }
    }, [isDiscounted]);

    useEffect(() => {
        if (maxPpvPrice && parseFloat(ppvPrice) > parseFloat(maxPpvPrice)) {
            setPriceHelpText(`Max $${parseFloat(maxPpvPrice)} USD`);
            setPriceError(true);
        }

        if (maxPpvPrice && parseFloat(ppvPrice) < parseFloat(minPpvPrice)) {
            setPriceHelpText(`Min $${parseFloat(minPpvPrice)} USD`);
            setPriceError(true);
        }

        if ((parseFloat(ppvPrice) >= parseFloat(minPpvPrice) && parseFloat(ppvPrice) <= parseFloat(maxPpvPrice)) || ppvPrice?.length === 0) {
            setPriceHelpText('');
            setPriceError(false);
        }

        if (parseFloat(promoPrice) > parseFloat(ppvPrice)) {
            setPromoPriceHelpText(`Max $${parseFloat(ppvPrice) - .1} USD`);
            setPromoPriceError(true);
        }
        if (parseFloat(promoPrice) < parseFloat(minPpvPrice)) {
            setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
            setPromoPriceError(true);
        }

        if ((parseFloat(promoPrice) > parseFloat(minPpvPrice) && parseFloat(promoPrice) < parseFloat(ppvPrice)) || promoPrice?.length === 0) {
            setPromoPriceHelpText('');
            setPromoPriceError(false);
        }
    }, [promoPrice, ppvPrice]);

    useEffect(() => {
        setPriceHelpText(`Min $${parseFloat(minPpvPrice)} USD`);
        setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
    }, [minPpvPrice]);

    const onHandleExpiryChange = (e) => {
        let value = e.target.value;

        if (value == '' || value == null || value == 0) {
            value = 0;
        } else if (value > 99) {
            return;
        } else {
            if (isNaN(Number(value))) {
                return;
            }

            value = Number(value).toString().replace(/^0+/, '');
        }

        setExpiry({
            ...expiry,
            [e.target.name]: value
        });
    };

    const handleShowOnShopAndPosts = () => {
        setShowOnShopAndPosts(showOnShopAndPosts => !showOnShopAndPosts);
    };

    return <Dialog
        className='modal-ppv-price'
        open={showPrice}
        onClose={handleClose}
        sx={{
            '& .MuiDialog-paper': {
                maxWidth: '320px',
                width: '320px',
            },
        }}
        fullWidth
    >
        <div className='modal-ppv-price-title'>
            <DialogTitle>PPV Price</DialogTitle>
            {
                onPosts &&
                <FormControlLabel
                    control={<Switch
                        checked={showOnShopAndPosts}
                        onChange={handleShowOnShopAndPosts}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                    label={onShop ? "Add to Posts" : <span className="add-to-shop-label">Add to Shop&nbsp;<i className="fa-regular fa-shopping-cart"></i>&nbsp;<strong>NEW</strong></span>}
                />
            }
        </div>
        <DialogContent className='modal-ppv-price-title'>
            <div style={{ marginTop: '10px' }}>
                <TextField
                    type='text'
                    id="promoPpvPrice"
                    label="Price"
                    variant="outlined"
                    value={ppvPrice}
                    onChange={handlePriceChange}
                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    size='small'
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    helperText={priceHelpText}
                    error={priceError}
                    style={{ width: '100%' }}
                />
            </div>
            <div style={{ marginTop: '10px' }}>
                <FormControlLabel
                    control={<Switch
                        checked={isDiscounted}
                        onChange={handleIsDiscounted}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                    label="Limited discount offer"
                />
            </div>
            {
                isDiscounted && <div style={{ marginTop: '10px' }}>
                    <TextField
                        type='text'
                        id="promoPpvPrice"
                        label="Discounted Price"
                        variant="outlined"
                        value={promoPrice}
                        onChange={handlePromoPriceChange}
                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                        size='small'
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        helperText={promoPriceHelpText}
                        error={promoPriceError}
                        style={{ width: '100%' }}
                    />
                </div>
            }
            {
                isDiscounted &&
                <>
                    <div style={{ marginTop: '22px', display: 'flex', gap: '4px' }}>
                        Limited offer expires in
                    </div>

                    <div className="limited-offer-ppv-date-picker">
                        <div className="price-modal-expiry-fields">
                            <div className="expiry-field">
                                <span>Days</span>
                                <TextField
                                    hiddenLabel
                                    name="days"
                                    variant="filled"
                                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                    value={expiry.days}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>

                            <div className="expiry-field">
                                <span>Hrs</span>
                                <TextField
                                    hiddenLabel
                                    name="hours"
                                    variant="filled"
                                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                    value={expiry.hours}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>

                            <div className="expiry-field">
                                <span>Mins</span>
                                <TextField
                                    hiddenLabel
                                    name="minutes"
                                    variant="filled"
                                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                    value={expiry.minutes}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </DialogContent>
        <DialogActions>
            <Button
                onClick={handleCancel}
            >Cancel</Button>
            <Button
                onClick={handleOk}
            >
                Ok
            </Button>
        </DialogActions>
    </Dialog>;
};

const mapStateToProps = state => ({
    user: state.user.user
});

export default connect(mapStateToProps)(ModalPPVPrice);